<script>
import Messages from './components/Messages.vue'
import Menu from './components/Menu.vue'
import UserMenu from './components/UserMenu.vue'
import lookups from './helpers/lookups'
import config from "@/helpers/config"
import notifications from './helpers/notifications'
export default {
  name: 'App',
  components: { Menu, UserMenu, Messages },
  data() {
    return {        
        customer: null,
        positionWidth: null,
        positionLeft: null
    }  
  },
  created()
  {
      if(localStorage.samfallifyUser == undefined || localStorage.samfallifyToken == undefined){
       
        this.$router.push('/login')      
      } else
      { 
        var user = JSON.parse(localStorage.samfallifyUser);
        this.$store.commit('setEntity', { entityName: 'user', entity: { name: user.first_name + " " + user.last_name, id: user.id, user_level: user.user_level }}); 
        if(this.$store.state.appearence != null)
        {
            this.applyThemeFromAppearance(this.$store.state.appearence);
        }
        this.getSettings();
        lookups.getLookups();   
        this.getCustomer(); 
        this.getAppearence();
        this.getWorkGroups(); 
        this.getUserOwnerCourses(); 
        this.getCourses();
        notifications.getNotifications();
        if(user.user_level == 'Redaktör') {
            this.$cache.createCache('adminOpenApplication', 'admin-open-application/');
        }

        var self = this;    
          window.addEventListener('resize', function(event) {
              self.setUserMenuSize();
          }, true);
      }
    },
    mounted()
    {      
        this.setUserMenuSize();

        $(document).on('click', function() {
            $('.v-tooltip').remove();
        });
    },
    methods:
    {
        normalizeThemeColor(colorValue)
        {
            return /^#([0-9A-F]{3}){1,2}$/i.test(colorValue) ? colorValue : '#A3BDA4';
        },
        adjustThemeColor(colorValue, amount)
        {
            var hex = this.normalizeThemeColor(colorValue).replace('#', '');
            if(hex.length == 3)
            {
                hex = hex.split('').map(function(char) { return char + char; }).join('');
            }

            var rgb = [
                parseInt(hex.substring(0, 2), 16),
                parseInt(hex.substring(2, 4), 16),
                parseInt(hex.substring(4, 6), 16)
            ];

            return '#' + rgb.map(function(channel) {
                var nextValue = Math.max(0, Math.min(255, channel + Math.round((255 * amount) / 100)));
                return nextValue.toString(16).padStart(2, '0');
            }).join('').toUpperCase();
        },
        getThemeContrastColor(colorValue)
        {
            var hex = this.normalizeThemeColor(colorValue).replace('#', '');
            if(hex.length == 3)
            {
                hex = hex.split('').map(function(char) { return char + char; }).join('');
            }

            var r = parseInt(hex.substring(0, 2), 16);
            var g = parseInt(hex.substring(2, 4), 16);
            var b = parseInt(hex.substring(4, 6), 16);
            var brightness = (r * 299 + g * 587 + b * 114) / 1000;

            return brightness > 160 ? '#111111' : '#FFFFFF';
        },
        applyThemeFromAppearance(appearence)
        {
            var baseColor = this.normalizeThemeColor(appearence != null ? appearence.app_color : null);
            var rootStyle = document.documentElement.style;

            rootStyle.setProperty('--theme-color-light', this.adjustThemeColor(baseColor, 5));
            rootStyle.setProperty('--theme-color-base', baseColor);
            rootStyle.setProperty('--theme-color-dark', this.adjustThemeColor(baseColor, -5));
            rootStyle.setProperty('--theme-color-text', this.adjustThemeColor(baseColor, -32));
            rootStyle.setProperty('--theme-color-border', this.adjustThemeColor(baseColor, -5));
            rootStyle.setProperty('--theme-color-input-bg', this.adjustThemeColor(baseColor, 28));
            rootStyle.setProperty('--theme-color-text-stroke', this.adjustThemeColor(baseColor, -40));
            rootStyle.setProperty('--theme-color-contrast', this.getThemeContrastColor(baseColor));
        },
        getBodyBackgroundImage(imageUrl)
        {
            return 'linear-gradient(to right, rgba(0,0,0, 0.70) 0%, rgba(0,0,0, 0.30) 20%, rgba(0,0,0, 0) 40%, rgba(0,0,0, 0) 100%), ' + imageUrl;
        },
        setUserMenuSize()
        {
            var position = document.getElementById("main-content").getBoundingClientRect();
            this.positionLeft = position.x;
            this.positionWidth = position.width;
        },
        getCustomer()
        {
          var self = this;
          this.$communicator.get("customers/")
            .then(function(data)
            {
                self.$store.commit('setEntity', { entityName: 'customer', entity: data })   
                if(data.background_image_name != null)
                {
                  var imageUrl = 'url("' + self.url + 'uploads/'+ data.id+'/images/'+ data.background_image_name + '")';
                  var backgroundImage = self.getBodyBackgroundImage(imageUrl);
                  $("body").css("background-image", backgroundImage);
                  localStorage.setItem("samfallifyBgImg", backgroundImage);
                } 
                
                
                
            })
            .fail(function(error) {
            
            }); 
        },
        getAppearence()
        {
          var self = this;
          this.$communicator.get("app-appearence/")
            .then(function(data)
            {
                self.applyThemeFromAppearance(data);
                self.$store.commit('setEntity', { entityName: 'appearence', entity: data })
            })
            .fail(function(error) {
            
            });
        },
        getWorkGroups()
        {
            var self = this;
            this.$communicator.get("work-groups-for-user/")
              .then(function(data)
              {
                self.$store.commit('setEntity', { entityName: 'userWorkGroups', entity: data })                            
              })
              .fail(function(error) {
              
              }); 
        }, 
        getUserOwnerCourses()
        {
            var self = this;
            this.$communicator.get("user-owner-courses/")
              .then(function(data)
              {
                self.$store.commit('setEntity', { entityName: 'userOwnerCourses', entity: data })                            
              })
              .fail(function(error) {
              
              }); 
        }, 
        getCourses()
        {
            var self = this;
            this.$communicator.get("courses/")
              .then(function(data)
              {
                self.$store.commit('setEntity', { entityName: 'courses', entity: data })                            
              })
              .fail(function(error) {
              
              }); 
        },       
        async getSettings()
        {
            const settings = await this.$communicator.get("settings/");
            this.$store.commit('setEntity', { entityName: 'settings', entity: settings })

        },     
        // async getnames()
        // {
        //     const settings = await this.$communicator.get("names/");
        //     this.$store.commit('setEntity', { entityName: 'settings', entity: settings })

        // },     
    },
    watch:
    {
        appearence: {
            handler(newValue)
            {
                this.applyThemeFromAppearance(newValue);
            },
            deep: true
        }
    },
    computed:
    {      
        url() { return config.urlToServer },
        appearence() { return this.$store.state.appearence },              
    }    
}
</script>
<template> 
  <Menu v-if="!this.$isMobile && this.$store.state.customer != null && this.$store.state.user != null" :positionLeft="positionLeft"></Menu>
  <UserMenu v-if="this.$store.state.customer != null  && this.$store.state.user != null" :positionLeft="positionLeft" :positionWidth="positionWidth"></UserMenu>
  <router-view></router-view>
  <Messages></Messages>
</template>
<style>
 
</style>
  
